<lcp-header *ngIf="fields" [isInverted]="!!fields['bannerColor']"></lcp-header>


<div class="main-content-container padding-bottom-0">
  <ng-container *ngIf="fields">
    <section [ngClass]="[
        'lcp-section', 
        !!fields['bannerColor'] ? 'is-banner' : '',
        fields['bannerColor'] ? 'is-background-' + fields['bannerColor'] : ''
      ]">
      <div class="lcp-section-content">
        <div class="display-flex">
          <h1 *ngIf="fields['title']" class="section-title margin-top-20 margin-bottom-80 flex-50-not-sm">
            {{ fields['title'] }}
          </h1>
        </div>
      </div>
    </section>


    <section *ngFor="let section of fields['sections']; let i = index;"
      [ngClass]="['lcp-section', 'lcp-' + section.fields['slug']]"
      [class.is-inverted]="section.fields['inverted']">

      <div class="lcp-section-content">
        <div class="display-flex">
          <p *ngIf="section.fields['title']" class="lcp-subheading flex-50-not-sm margin-bottom-120">
            {{ section.fields['title'] }}
          </p>
        </div>

        <ng-content *ngTemplateOutlet="collectionsCardsTemplate; context:{ section: section }"></ng-content>
      </div>
    </section>
  </ng-container>
</div> 

<ng-template #collectionsCardsTemplate let-section="section">
  <div class="section-main-content">
    <div class="collections-collections-container">
      <ng-container *ngFor="let block of section.fields['items']; index as index">
        
        <div class="collections-collection-container">
          <div class="collection-wrapper-mobile typable-wrapper-mobile display-block-only-sm">
            <ng-content *ngTemplateOutlet="collectionsCollectionMobile; context:{ block: block, index: index }"></ng-content>
          </div>

          <div class="collection-wrapper-desktop  typable-wrapper-desktop display-none-sm">
            <ng-content *ngTemplateOutlet="collectionsCollectionDesktop; context:{ block: block, index: index }"></ng-content>
          </div> 
        </div>

          <!-- <div [ngClass]="['collections-collection', 'collections-collection-' + index, 'typable-container']" 
            (mouseover)="handleHoverCollection({ event: $event, block: block, index: index })"
            (focus)="handleHoverCollection({ event: $event, block: block, index: index })"
            (mouseleave)="handleBlurCollection({ event: $event, index: index })"
            (click)="handleSelectCollection(block)"
            (keydown.enter)="handleSelectCollection(block)"
            tabindex="0"> -->

            <!-- <div class="collections-collection-flex">
              <h3 class="collections-collection-title lcp-subheading">{{ block.fields['title'] }}</h3>

              <lcp-rich-text
                class="collections-collection-body lcp-font-size-small"
                [document]="block.fields['body']">
              </lcp-rich-text>

              <ng-container *ngIf="this.lcpHelper.linkFromBlock(block)">
                <div class="collections-show-more-link-container margin-0">
                  <a class="collections-show-more-link" [href]="this.lcpHelper.linkFromBlock(block)?.['address'] || '#'">
                    <div class="typable-text-container">
                      <div class="typable-cursor-empty"></div>
                      <div class="typable-text-outer">
                        <span class="typable-text typable-repeatable"></span>
                        <span class="typable-cursor-container">
                          <div class="typable-cursor"></div>
                        </span>
                      </div>
                      <div class="typable-text-placeholder word-break-all">{{ linkPlaceholder }}</div>
                    </div>
                  </a>
                </div>
              </ng-container>
                
              <div *ngIf="learnMoreArrowMedia"
                class="collections-collection-learn-more-image-container">
                <img class="collections-collection-learn-more-image" [src]="lcpHelper.urlFromMedia(learnMoreArrowMedia)">
              </div>
            </div>
          </div> -->

          <!-- <div class="collection-wrapper-mobile typable-wrapper-mobile display-block-only-sm">
            <ng-content *ngTemplateOutlet="collectionsCollectionMobile; context:{ block: block, index: i }"></ng-content>
          </div>

          <div class="collection-wrapper-desktop  typable-wrapper-desktop display-none-sm">
            <ng-content *ngTemplateOutlet="collectionsCollectionDesktop; context:{ block: block, index: i }"></ng-content>
          </div>  -->
          
         <!-- <div class="collections-collection-image-container">
            <div class="collections-collection-image" *ngIf="block.fields['media']">
              <img [src]="lcpHelper.urlFromMedia(block.fields['media'][0])">
            </div>
          </div> -->

        <!-- </div> -->
      </ng-container>
    </div>
  </div>
  
</ng-template>


<ng-template #collectionsCollectionDesktop let-block="block" let-index="index">

  <div [ngClass]="['collections-collection', 'collections-collection-' + index, 'typable-container']" 
    (mouseover)="handleHoverCollection({ event: $event, block: block, index: index })"
    (focus)="handleHoverCollection({ event: $event, block: block, index: index })"
    (mouseleave)="handleBlurCollection({ event: $event, index: index })"
    (click)="handleSelectCollection(block)"
    (keydown.enter)="handleSelectCollection(block)"
    tabindex="0">

    <div class="collections-collection-flex">
      <h3 class="collections-collection-title lcp-subheading">{{ block.fields['title'] }}</h3>

      <lcp-rich-text
        class="collections-collection-body lcp-font-size-small"
        [document]="block.fields['body']">
      </lcp-rich-text>

      <ng-container *ngIf="this.lcpHelper.linkFromBlock(block)">
        <!-- a div, not a <p>: a <p> can't contain the <div>s below, which breaks hydration -->
        <div class="collections-show-more-link-container margin-0">
          <a class="collections-show-more-link" [href]="this.lcpHelper.linkFromBlock(block)['address'] || '#'">
            <div class="typable-text-container">
              <div class="typable-cursor-empty"></div>
              <div class="typable-text-outer">
                <span class="typable-text typable-repeatable"></span>
                <span class="typable-cursor-container">
                  <div class="typable-cursor"></div>
                </span>
              </div>
              <div class="typable-text-placeholder word-break-all">{{ linkPlaceholder }}</div>
            </div>
          </a>
        </div>
      </ng-container>
        
      <div *ngIf="learnMoreArrowMedia"
        class="collections-collection-learn-more-image-container">
        <img class="collections-collection-learn-more-image" [src]="lcpHelper.urlFromMedia(learnMoreArrowMedia)">
      </div>
    </div>
  </div>

  <!-- <div [ngClass]="['collections-collection', 'collections-collection-' + index, 'typable-container']" 
    [id]="'collections-collection-desktop-' + index"
    (mouseover)="handleHoverCollection({ event: $event, block: block, index: index })"
    (mouseleave)="handleBlurCollection({ event: $event, index: index })"
    (click)="handleSelectCollection(block)"
    (keydown.enter)="handleSelectCollection(block)"
    tabindex="0">

    <div class="collections-collection-flex">
      <div class="collections-collection-flex-left">
        <h4 class="collections-collection-title">{{ block.fields['title'] }}</h4>
        <div class="typable-text-container">
          <div class="typable-cursor-empty"></div>
          <div class="typable-text-outer">
            <span class="typable-text"></span>
            <span class="typable-cursor-container">
              <div class="typable-cursor"></div>
            </span>
          </div>
          <div class="typable-text-placeholder">{{ lcpHelper.richTextToString(block.fields['body']) + " learn more" }}</div>
        </div>
      </div>
      
      <div class="collections-collection-flex-right">
        <div *ngIf="learnMoreArrowMedia"
          class="collections-collection-learn-more-image-container">
          <img class="collections-collection-learn-more-image" [src]="lcpHelper.urlFromMedia(learnMoreArrowMedia)">
        </div>
      </div>
    </div>
  </div> -->
</ng-template>

<ng-template #collectionsCollectionMobile let-block="block" let-collection="collection">
  <div class="collections-collection typable-container"
    (click)="handleSelectCollection(block)">
    <div class="collections-collection-flex">
      <div class="collections-collection-flex-left">
        <h4 class="collections-collection-title lcp-subheading">{{ block.fields['title'] }}</h4>
        <div class="typable-text-container">
          <div class="typable-cursor-empty"></div>
          <div class="typable-text-outer">
            <span class="typable-text"></span>
            <span class="typable-cursor-container">
              <div class="typable-cursor"></div>
            </span>
          </div>
          <div class="typable-text-placeholder">{{ lcpHelper.richTextToString(block.fields['body']) + " learn more" }}</div>
        </div>
      </div>
      
      <div class="collections-collection-flex-right">
        <!-- <div *ngIf="learnMoreArrowMedia"
          class="collections-collection-learn-more-image-container">
          <img class="collections-collection-learn-more-image" [src]="lcpHelper.urlFromMedia(learnMoreArrowMedia)">
        </div> -->
        <!-- <div class="collections-collection-image">
          <img [src]="lcpHelper.urlFromMedia(block.fields['media'][0])">
        </div> -->
      </div>
    </div>
  </div>
</ng-template>

<ng-template #collectionsBottomSection let-section="section">
  <ng-container *ngFor="let block of section.fields['items']; index as i">
    <div class="display-flex collections-our-strategy-flex">
      <div class="flex-45-not-sm">
        <h2 *ngIf="fields['title']" class="section-title">
          {{ section.fields['title'] }}
        </h2>
        <div class="section-main-content">
            <lcp-rich-text
              [document]="block.fields['body']">
            </lcp-rich-text>
            <!-- class="lcp-subheading" -->
        </div>
      </div>

      <div class="flex-50-not-sm">
        <div *ngIf="block.fields['media']" class="collections-img--our-strategy">
          <img [src]="lcpHelper.urlFromMedia(block.fields['media'][0])">
        </div>
      </div>
    </div>
  </ng-container>

  
</ng-template>